import moment from "moment-timezone";

import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";
import { formatDatesAndTimesForPostRequest } from "api/utils/formatDatesAndTimesForPostRequest";

import { MeetingCalendarEvent } from "components/MeetingCalendar/MeetingCalendar";
import { Medium } from "hooks/useAvailableMediums";

type Params = {
	hostUid: string;
	guestUid: string;
	paymentTokenId: string;
	paymentTokenType: "singleSessionPrice";
	message: string;
	medium: Medium;
	sessionEvent: MeetingCalendarEvent;
};

export const sendMeetingRequest = makeSubmitData<Params>(
	"meetingRequest",
	undefined,
	({ sessionEvent: { start, end, ...sessionEventRest }, ...rest }) => ({
		...rest,
		sessionEvent: formatDatesAndTimesForPostRequest({
			startUTC: moment.utc(start).toDate(),
			endJustBeforeUTC: moment.utc(end).toDate(),
			...sessionEventRest
		})
	})
);
